import mitt from 'mitt';
import defaultSlotList from '@/components/page-model/slotList';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { reactive, ref } from 'vue';
import { message } from 'ant-design-vue';
import { create_card } from '@/api/mjstore-model';
import modalBox from '@/components/form-modal/modal-tools';

export const event_obj = mitt();
export const btn_list = null;
export const slotList = defaultSlotList;
export const config = {
  creatCol: [],
  updateCol: [],
};
const field_disable_hd = ref(false);
const field_disable_month_num = ref(false);

export const head_btn_list = [
  {
    name: '新建卡',
    clazz: 'primary',
    icon: 'plus-outlined',
    is_show: (record: any) => {
      return record.is_active;
    },
    cb: () => {
      const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

      // 模态框，确认按钮点击。
      const editModal = reactive({
        visible: true,
        loading: false,
        title: '新建卡',
        form: {
          settings: {
            labelAlign: 'right',
            layout: 'horizontal',
            col: [],
            labelCol: {
              span: 5,
            },
            wrapperCol: {
              span: 18,
            },
          },
          fields: [
            {
              type: 'input',
              name: 'name',
              label: '卡名称',
              disabled: false,
              allowClear: true,
              inputType: 'text',
              defaultValue: '',
              placeholder: '请填写卡名称',
            },
            {
              type: 'input',
              name: 'price',
              label: '单价',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写单价',
            },
            {
              type: 'input',
              name: 'max_num',
              label: '最大使用次数',
              disabled: false,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写最大使用次数',
            },
            {
              type: 'radio',
              name: 'card_type',
              label: '卡类型',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: '',
              placeholder: '请选择卡类型',
            },
            {
              type: 'input',
              name: 'month_num',
              label: '有效期（月）',
              disabled: field_disable_month_num,
              allowClear: true,
              inputType: 'number',
              defaultValue: '',
              placeholder: '请填写有效期（月）',
            },
            {
              type: 'remoteselect',
              name: 'project_type_id',
              label: '项目分类',
              disabled: false,
              placeholder: '请选择项目分类',
              datasourceType: 'remote',
              mode: 'default',
              allowClear: true,
              modalType: 'mjstore-projecttype',
            },
            {
              type: 'radio',
              name: 'is_any_project',
              label: '任意项目可做',
              disabled: false,
              allowClear: true,
              labelKey: 'name',
              valueKey: 'value',
              defaultValue: '',
            },
            {
              type: 'remotemodal',
              name: 'project_ids',
              label: '项目范围',
              disabled: field_disable_hd,
              placeholder: '请选择可做项目范围',
              datasourceType: 'remote',
              labelKey: 'code',
              mode: 'multiple',
              allowClear: true,
              modalType: 'mjstore-project',
            },
          ],
          rules: {
            name: [{ required: true, message: '请填输入卡名称' }],
            month_num: [{ required: true, message: '请输入月数' }],
            project_type_id: [{ required: true, message: '请填输入项目分类' }],
          },
          model: reactive({
            org_id: current_org?.id,
            is_active: true,
            name: null,
            price: null,
            max_num: null,
            month_num: null,
            card_type: null,
            is_any_project: false,
            p_type: [1, 11, 21],
            project_type_id: null,
          }),
          watch: {
            is_any_project: (data: any) => {
              if (data.is_any_project) {
                field_disable_hd.value = true;
              } else if (!data.is_any_project) {
                field_disable_hd.value = false;
              }
            },
            card_type: (data: any) => {
              if (data.card_type == 11) {
                field_disable_month_num.value = false;
              } else {
                field_disable_month_num.value = true;
                data.month_num = 0;
              }
            },
          },
        },
        options: {
          card_type: [
            { value: 1, name: '次卡' },
            { value: 11, name: '时间卡' },
            { value: 21, name: '产品卡' },
            { value: 31, name: '二次卡' },
          ],
          is_any_project: [
            { value: true, name: '是' },
            { value: false, name: '否' },
          ],
        },
        ok: (payload: any) => {
          return new Promise(resolve => {
            editModal.loading = true;
            create_card(payload)
              .then(() => {
                message.success('创建成功');
                event_obj.emit('refresh');
                resolve(null);
              })
              .finally(() => {
                editModal.loading = false;
              });
          });
        },
      });
      modalBox(editModal);
    },
  },
  // {
  //   name: '导出',
  //   clazz: 'primary',
  //   cb: (search_model: any) => {
  //     const current_org = ls.get(STORAGE_CURRENT_ORG_KEY);
  //     const payload: any = {
  //       org_id: current_org?.id,
  //       ...search_model,
  //     };
  //     let params_str = '';
  //     Object.keys(payload).forEach(key => {
  //       if (payload[key] != null && key != 'current' && key != 'pageSize') {
  //         params_str += key + '=' + payload[key] + '&';
  //       }
  //     });
  //     window.open(
  //       '/mjstore/query_card_list?export=true&' + params_str + new Date().getTime(),
  //       '_blank',
  //     );
  //     message.success('导出成功');
  //   },
  // },
];
